var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.85723 8.94851H22.7144V11.1929C22.7144 11.7571 23.4087 12.033 23.8072 11.6317L27.3944 8.13351C27.6515 7.88274 27.6515 7.49405 27.3944 7.24328L23.8072 3.74505C23.4087 3.35636 22.7144 3.6322 22.7144 4.19643V6.44082H8.57152C7.86438 6.44082 7.2858 7.00505 7.2858 7.69467V12.7101C7.2858 13.3997 7.86438 13.9639 8.57152 13.9639C9.27866 13.9639 9.85723 13.3997 9.85723 12.7101V8.94851ZM22.7144 21.487H9.85723V19.2426C9.85723 18.6784 9.16295 18.4025 8.76438 18.8037L5.17723 22.302C4.92009 22.5527 4.92009 22.9414 5.17723 23.1922L8.76438 26.6904C9.16295 27.0791 9.85723 26.8033 9.85723 26.2391V23.9947H24.0001C24.7072 23.9947 25.2858 23.4304 25.2858 22.7408V17.7254C25.2858 17.0358 24.7072 16.4716 24.0001 16.4716C23.2929 16.4716 22.7144 17.0358 22.7144 17.7254V21.487Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.dcc8af7df4d0595d596a61e4e7788966.svg";
export { ForwardRef as ReactComponent };